import { render, staticRenderFns } from "./ProductCardWithAttributes.vue?vue&type=template&id=2f16567d&"
import script from "./ProductCardWithAttributes.vue?vue&type=script&lang=js&"
export * from "./ProductCardWithAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports